import { Component } from '@angular/core';

@Component({
    selector: 'app-password-request',
    templateUrl: './request.component.html',
    styleUrls: ['./password.component.scss']
})
export class PasswordRequestComponent {
}
